document.querySelectorAll('[data-toggle="modal"]').forEach(link => {
    const target = link.getAttribute('data-target');
    const modal = document.querySelector(target);

    if (modal) {
        modal.addEventListener('show.bs.modal', () => {
            link.setAttribute('aria-expanded', 'true');
        });

        modal.addEventListener('hide.bs.modal', () => {
            link.setAttribute('aria-expanded', 'false');
        });
    }
});
